const baseState = {
    removedTokenList: [],
    selectedToken: null,
    tokenEnquire: null,
    tokenEnquireSetted: false,
    isMounted: false
}

const removedTokenListReducer = (state = baseState, { type, payload }) => {

    switch (type) {
    	case "SET_REMOVED_TOKEN_LIST": {
			return {
				...state,
				removedTokenList: payload
			}
		}

        case "SET_SELECTED_TOKEN_REMOVED": {
            return {
                ...state,
                selectedToken: payload
            }
        }

        case "SET_TOKEN_ENQUIRE_REMOVED": {
            return {
                ...state,
                tokenEnquire: payload,
                tokenEnquireSetted: true
            }
        }

        case "SET_REMOVED_IS_MOUNTED": {
            return {
                ...state,
                tokenEnquire: payload,
                isMounted: true
            }
        }

        case "CLEAR_TOKEN_ENQUIRE_REMOVED": {
            return {
                ...state,
                tokenEnquire: null,
                tokenEnquireSetted: false
            }
        }

        default:
            return state;
    }
}

export default removedTokenListReducer